import { Typography, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { A11ySettingsAudioControls } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@a11y/A11ySettings/components/AudioControls';
import { Checkbox } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@a11y/A11ySettings/components/Checkbox';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { FONT_GSS_FUTURA_BOOK } from '@monorepo/shared/src/themes/defaultTheme';

const t = (key: string, options?) => translate('preferences', key, options);

const AudioControls = ({ handleToggle, handleScaling, audioSettings }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} md={12} lg={10} className={classes.gridSection}>
      <Grid container className={classes.grid}>
        <Grid item xs={12} md={5} className={classes.gridContentLeft}>
          <Typography className={classes.title} variant="h5">
            {t('audioControls')}
          </Typography>
          <div className={classes.labelText}>
            <Checkbox
              checked={audioSettings.displayAudioControls}
              onChange={handleToggle('audioSettings', 'displayAudioControls')}
              labelText={t('audioControlsButtonLabel')}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6} className={classes.gridContentRight}>
          <span className={`${classes.labelText} ${classes.labelTextLeft}`}>
            {t('audioControls')}
          </span>
          <span className={classes.labelTextScale}>
            <A11ySettingsAudioControls
              onToggleChange={handleToggle}
              onScalingChange={handleScaling}
              muteSounds={audioSettings.muteSounds}
              volume={audioSettings.volume}
            />
          </span>
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  grid: {
    paddingBottom: 10,
  },
  title: {
    fontSize: '18px',
    lineHeight: '40px',
  },
  gridSection: {
    margin: 20,
    borderRadius: '5px',
    border: '1px solid lightGray',
  },
  gridContentRight: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  gridContentLeft: {
    margin: `5px 10px`,
  },
  labelText: {
    fontSize: '16px',
    fontFamily: FONT_GSS_FUTURA_BOOK,
    display: 'flex',
    alignItems: 'center',
    '& input': {
      margin: 0,
      width: '20px',
      height: '20px',
    },
    '& input:focus': {
      boxShadow: 'none !important',
    },
    '& span': {
      paddingLeft: 10,
    },
    '& label': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  labelTextLeft: {
    paddingRight: 10,
  },
  labelTextScale: {
    fontSize: '16px',
    fontFamily: FONT_GSS_FUTURA_BOOK,
    '& .lwt-common-labeltext': {
      paddingRight: 10,
    },
  },
}));

export default AudioControls;
